import LocationsClient from '@/clients/locations/LocationsClient'
import ContactDetailsClient from '@/clients/contact-details/ContactDetailsClient'
import LocationDTO from '@/entities/LocationDTO'

export async function getLocationsForPractice (practiceUuid) {
  const client = new LocationsClient(practiceUuid)
  const locations = await client.getLocations(practiceUuid)
  return locations
    .map(location => (new LocationDTO(location)))
}

export async function getProvisionedNumbers (practiceUuid, locationUuids) {
  const client = new ContactDetailsClient()
  const contactDetails = await client.getContactDetails(practiceUuid, locationUuids)
  return contactDetails.reduce((provisionedContactDetails, contactDetail) => {
    const provisionedNumbers = contactDetail.phone_numbers?.filter(phoneNumber => phoneNumber.label === 'PROVISIONED') || []
    if (provisionedNumbers.length === 0) {
      return provisionedContactDetails
    }
    provisionedContactDetails.push({
      locationId: contactDetail.entity_uuid,
      provisionedNumber: provisionedNumbers[0].number
    })
    return provisionedContactDetails
  }, [])
}
